import { availableToken } from '@paradigm/api/src/internal/token';
import createPapiWebSocket from '@paradigm/api/src/internal/createPapiWebSocket';
import { PositionsWebSocket } from '#/positions/entities/types';
import { processNotification } from '#/positions/entities/positions';

export function createPositionsWebSocket(): PositionsWebSocket {
  return createPapiWebSocket({
    urlProvider,
    processNotification,
  });
}

async function urlProvider() {
  const token = await availableToken();
  return `${PAPI_URL_WS}/v1/positions?token=${encodeURIComponent(token)}`;
}
